// © 2013 - 2021 Tinder, Inc., ALL RIGHTS RESERVED

import { THEME_DARK, THEME_DEFAULT } from '@tinderapp/ui-core';

export const DEFAULT_THEMES = {
  light: THEME_DEFAULT,
  dark: THEME_DARK,
};

export const DEFAULT_THEME_ID: keyof typeof DEFAULT_THEMES = 'light';
